module.exports = __webpack_public_path__ + "static/img/bg_banner.dc1a61e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_banner.jpeg
// module id = /XQ5
// module chunks = 0